import { render, staticRenderFns } from "./ProductionLogDetails.vue?vue&type=template&id=3a04e01b"
import script from "./ProductionLogDetails.vue?vue&type=script&lang=js"
export * from "./ProductionLogDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports